export enum NodeV2CommandsUiEnum {
  SEND_BACKWARD = 'SEND_BACKWARD',
  BRING_FORWARD = 'BRING_FORWARD',
  ELEMENT_IN_FLOW = 'ELEMENT_IN_FLOW',
  FLEX_FLOW = 'FLEX_FLOW',
  GROW = 'GROW',
  SHRINK = 'SHRINK',
  ADD_ROW_ABOVE = 'ADD_ROW_ABOVE',
  ADD_ROW_BELOW = 'ADD_ROW_BELOW',
  MOVE = 'MOVE',
  MOVE10 = 'MOVE10',
  NAVIGATE = 'NAVIGATE',
  COPY = 'COPY',
  CUT = 'CUT',
  DELETE = 'DELETE',
  CLONE = 'CLONE',
  WRAP_IN_CONTAINER = 'WRAP_IN_CONTAINER',
  WRAP_IN_BUTTON = 'WRAP_IN_BUTTON',
  UNWRAP = 'UNWRAP',
  HIDE = 'HIDE',
  LOCK = 'LOCK',
  SHOW_GRID = 'SHOW_GRID',
}
